import { useBrand } from "../brand/brand-context";
import { useMemo } from "react";
import useFractionPersistValue, {
  FractionPersistKey,
} from "../useFractionPersistValue";

export default function useSessionChecks(userInfo) {
  const brand = useBrand();
  const alohomoraEnabled = brand.getProp("Alohomora.enabled");
  const skippedSSO = useFractionPersistValue<boolean>(
    userInfo,
    FractionPersistKey.SKIPPED_SSO
  );

  const needsEmailVerification =
    brand.getProp("EmailVerification.enabled") &&
    userInfo.emailVerificationRequired &&
    !userInfo.emailVerificationCompleted;

  // Alohomora will perform any sso completion before landing in supernova
  const needsSSOCompletion =
    !alohomoraEnabled &&
    userInfo.ssoOnly &&
    (brand.getProp("AccountCompletion.force") ||
      (!skippedSSO &&
        brand.getProp("AccountCompletion.enabled") &&
        !brand.getProp("AccountCompletion.ssoOnly")));

  const needsTOSCompletion =
    !userInfo.eulaAccepted && !brand.getProp("AccountCompletion.skipTOS");

  return useMemo(
    () => ({
      needsEmailVerification,
      needsSSOCompletion,
      needsTOSCompletion,
    }),
    [needsEmailVerification, needsSSOCompletion, needsTOSCompletion]
  );
}
